import { localizeIt } from "components/service/localize";

const trimValue = (value) => value ? value.trim() : "";
const statusLabelByValue = (value) => {
    switch (value) {
        case "new":
            return localizeIt("DAMAGE.Status_Label_New");
        case "check":
            return localizeIt("DAMAGE.Status_Label_Check");
        case "double_check":
            return localizeIt("DAMAGE.Status_Label_DCheck");
        default:
            return "";
    }
};

export const damageFilterFieldsConfig = {
    damageStatus: {
        filterGroup: "where",
        column: "STATUS",
        operator: "EQ",
        getValue: (value) => value || "",
        getLabel: (value) => statusLabelByValue(value),
        getInitialValue: (item = {}) => item.value || null
    },
    hallName: {
        filterGroup: "whereStand",
        column: "HALL_NAME",
        operator: "EQ",
        getValue: (value) => trimValue(value),
        getLabel: (value) => `${ localizeIt("GLOBAL.Card_Hero_Hall") }: ${ trimValue(value) }`,
        getInitialValue: (item = {}) => item.value || null
    },
    block: {
        filterGroup: "whereStand",
        column: "BLOCK",
        operator: "EQ",
        getValue: (value) => trimValue(value),
        getLabel: (value) => `${ localizeIt("GLOBAL.Card_Hero_Block") }: ${ trimValue(value) }`,
        getInitialValue: (item = {}) => item.value || null
    },
    standNumber: {
        filterGroup: "whereStand",
        column: "STAND_NUMBER",
        operator: "EQ",
        getValue: (value) => trimValue(value),
        getLabel: (value) => `${ localizeIt("GLOBAL.Card_Hero_Stand") }: ${ trimValue(value) }`,
        getInitialValue: (item = {}) => item.value || null
    }
};

export const getDamageFilterInitialValues = (data) => {
    return Object.entries(damageFilterFieldsConfig).reduce((acc, [key, config]) => {
        const currentItem = data[config.filterGroup][key];

        return {
            ...acc,
            [key]: config.getInitialValue(currentItem)
        };
    }, {});
};

export const getDamageActiveFiltersCount = (values) => {
    return Object.entries(damageFilterFieldsConfig).reduce((count, [key, config]) => {
        const value = config.getValue(values[key]);

        return value ? count + 1 : count;
    }, 0);
};

export const buildDamageFilterState = (values, data) => {
    return Object.entries(damageFilterFieldsConfig).reduce((acc, [key, config]) => {
        const value = config.getValue(values[key]);
        const nextItem = value ? {
            label: config.getLabel(values[key]),
            column: config.column,
            operator: config.operator,
            value
        } : {};

        return {
            ...acc,
            [config.filterGroup]: {
                ...acc[config.filterGroup],
                [key]: nextItem
            }
        };
    }, {
        ...data,
        where: {
            ...data.where
        },
        whereStand: {
            ...data.whereStand
        },
        activeFilters: getDamageActiveFiltersCount(values)
    });
};
